<template>
  <div id="pano"></div>
</template>

<script>
import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex'
const log = require('bows')('KrpanoViewer', '[FE]')


async function loadScript(url, callback, callbackError) {
  const script = document.createElement('script')
  script.type = 'text/javascript'
  try {
    if (script.readyState) {
      // IE
      script.onreadystatechange = function () {
        if (script.readyState === 'loaded' || script.readyState === 'complete') {
          script.onreadystatechange = null
          callback()
        }
      }
    } else {
      script.onload = function () {
        callback()
      }
    }
    script.src = url
    document.getElementsByTagName('head')[0].appendChild(script)
  } catch (e) {
    if (null !== callbackError) {
      callbackError(e)
    }
  }
}

export default {
  props: {
    xml: {
      type: String,
      required: true
    },
    canMove: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters(['language', 'tourFeatures'])
  },
  methods: {
    ...mapActions({
      sendTracking: 'TRACKER_SEND_EVENT',
      setIsMobileDevice: 'SET_IS_MOBILE_DEVICE'
    }),
    init() {
      /* eslint no-undef: 0 */
      embedpano({
        swf: null,
        id: 'krpanoSWFObject',
        xml: null,
        target: 'pano',
        html5: 'only',
        webglsettings: {
          preserveDrawingBuffer: true
        },
        mobilescale: 1.0,
        passQueryParameters: true,
        onready: this.krpano_onready_callback
      })
    },
    goto(data) {
      global.krpano.call('goto(' + data + ')')
    },
    forceview(data) {
      global.krpano.call('forceview(' + data.hlookat + ',' + data.vlookat + ')')
    },
    emitPopupHotspotClickEvent(popupId) {
      if (this.canMove) this.$emit('popupHotspotClick', popupId)
    },

    emitTourMapClickEvent() {
      if (this.canMove) this.$emit('tourMapClick')
    },
    emitVideoClickClickEvent(videoURL) {
      if (this.canMove) this.$emit('videoClick', videoURL)
    },

    emitStreamViewSendEvent(data) {
      this.$emit('streamViewSend', data)
    },

    emitStreamPosSendEvent(data) {
      if (this.canMove) {
        this.$emit('streamPosSend', data)
        log(`Viewpoint clicked: ${data}`)
        this.sendTracking({ action: 'viewpoint_clicked', category: 'user_interactions', label: data })
      }
    },

    async krpano_onready_callback(krpano_interface) {
      global.krpano = krpano_interface
      this.setIsMobileDevice(global.krpano.get('device').mobile)
      await this.initPano()
    },

    async initPano() {
      await this.loadPano()
    },

    async loadPano() {
      if (!global.krpano) {
        return
      } else {
        // log(this.xml)
        global.krpano.call('loadxml(' + this.xml + ', null, MERGE, NOBLEND)')

        if (this.canMove) {
          global.krpano.call('unlockmove()')
        } else {
          global.krpano.call('lockmove()')
        }
        global.krpano.call(`update_language(${this.language})`)
      }
    }
  },
  beforeCreate() {
    window.Event = new (class {
      constructor() {
        this.vue = new Vue()
      }
      fire(event, data = null) {
        this.vue.$emit(event, data)
      }
      listen(event, callback) {
        this.vue.$on(event, callback)
      }
    })()
  },
  created() {
    Event.listen('popupHotspotClick', this.emitPopupHotspotClickEvent)
    Event.listen('tourMapClick', this.emitTourMapClickEvent)
    Event.listen('videoClick', this.emitVideoClickClickEvent)
    Event.listen('streamViewSend', this.emitStreamViewSendEvent)
    Event.listen('streamPosSend', this.emitStreamPosSendEvent)
  },
  async mounted() {
    if (this.xml != null) {
      if (!global.krpano) {
        await loadScript('/krpano/krpano.js', this.init)
      } else {
        await this.init()
      }
    }
  },
  watch: {
    async xml(newValue) {
      if (newValue != null) {
        if (!global.krpano) {
          await loadScript('/krpano/krpano.js', this.init)
        } else {
          await this.init()
        }
      }
    },
    canMove(newValue) {
      if (!global.krpano) {
        return
      } else {
        if (newValue) {
          global.krpano.call('unlockmove()')
        } else {
          global.krpano.call('lockmove()')
        }
      }
    }
  }
}
</script>

<style scoped>
#pano {
  z-index: 10;
  width: 100%;
  height: 100%;
}
</style>
